import React, { useContext, useEffect, useMemo, useState } from "react";
import styles from "@/page-components/budgets/components/budgets.module.css";
import {
  FilterSearch,
  FilterSearchToggle,
} from "@/components/filter-search/filter-search";
import { Button } from "react-bootstrap";
import add from "@/assets/img/add.svg";
import {
  useAccountFilterBudgets,
  useAccountFilterManagementBudgets,
} from "@/services/budget/getBudgetFilterAccounts.repo";
import { useFilterBudgetsTag } from "@/services/budget/getBudgetTagKeys.repo";
import TagItem from "./budgetsFilterDimensionTags";
import { useRgFilterBudgets } from "@/services/budget/getBudgetFilterRg.repo";
import { BudgetContext } from "../budget.context";
import { useNavigate, useSearchParams } from "react-router-dom";
import { UseAllAWSAccountStatics } from "@/services/budget/getBugetsAccount.repo";

const BudgetFilterSection = ({
  dimensionKeys,
  name,
  service,
  selectedValues,
  setSelectedValues,
  setSelectedTags,
  selectedTags,
}) => {
  const [selectedTittle, setSelectedTittle] = useState(null);
  const navigate = useNavigate();
  const [count, setCount] = useState(1);
  const context = useContext(BudgetContext);
  const [searchParams] = useSearchParams();
  const scope = searchParams.get("scope");
  useEffect(() => {
    if (scope && service === "gcp") {
      context?.setSelectedGcpRadio(scope);
    }
  }, []);

  let query = {
    service,
    scope: context?.selectedGroup,
  };

  let queryAzure = {
    service,
    scope: context?.selectedGroup,
  };

  const subscriptions =
    selectedValues?.account && (selectedValues?.account || []).map((e) => e.id);

  let azureQuery = useMemo(() => {
    return {
      service,
      subscriptions: { subscriptions: subscriptions },
      scope: context?.selectedGroup,
    };
  }, [context?.selectedGroup, service, subscriptions]);

  const management = useAccountFilterManagementBudgets(
    queryAzure,
    [],
    service === "azure"
  );
  const dropdown = useAccountFilterBudgets(query, [], {
    enabled: service !== "gcp",
  });
  // const dimensionKeys = useFilterBudgetsTag(query);
  const azureFilterRg = useRgFilterBudgets(
    azureQuery,
    [],
    context?.selectedGroup === "resource_group" && subscriptions?.length > 0
  );

  useEffect(() => {
    const storedFilters = localStorage.getItem("budgetFilters");
    if (storedFilters) {
      const parsed = JSON.parse(storedFilters);
      context?.setSelectedGroup(parsed.selectedGroup);
      setSelectedValues(parsed.selectedValues || {});

      if (parsed?.selectedTags) {
        setSelectedTags(parsed.selectedTags);
      }

      localStorage.removeItem("budgetFilters");
      context?.setIsRadioChanged(false);
    } else if (context?.isRadioChanged) {
      setSelectedValues({});
      setSelectedTags([
        {
          filterOn: "",
          filterType: "include",
          values: [],
        },
      ]);
      context?.setIsRadioChanged(false);
    }
    const params = new URLSearchParams(window.location.search);
    params.set("page", "1");
    navigate(`?${params.toString()}`);
  }, [context?.selectedGroup]);
  const query2 = useMemo(() => {
    return {
      scope: context?.selectedGcpRadio,
      service,
    };
  }, [context?.selectedGcpRadio, service]);
  const { data: totaldata, isLoading: gcpLoading } =
    UseAllAWSAccountStatics(query2);

  return (
    <>
      <div className={styles.filterContainer}>
        <div className={styles.filterHeader}>Filters</div>

        {service === "aws" && (
          <>
            <div style={{ marginTop: "16px" }}>
              <Filter
                tittle={name}
                setSelectedTittle={setSelectedTittle}
                setSelectedValues={setSelectedValues}
                data={dropdown?.data?.data}
                isLoading={dropdown?.isLoading}
                filterType="account"
                selectedValues={selectedValues}
              />
            </div>
          </>
        )}
        {service === "azure" && (
          <>
            <span className="filterScopeSelection">Scope</span>
            <span
              className="radioButtonContainer"
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: "16px",
              }}
            >
              <RadioButton
                name="scope"
                value="management_group"
                title="Management Group "
                contextKey="selectedGroup"
              />
              <RadioButton
                name="scope"
                value="subscription"
                title="Subscription"
                contextKey="selectedGroup"
              />
              <RadioButton
                name="scope"
                value="resource_group"
                title="Resource Group"
                contextKey="selectedGroup"
              />
            </span>
            {context?.selectedGroup === "management_group" && (
              <Filter
                tittle="Management Group"
                setSelectedTittle={setSelectedTittle}
                setSelectedValues={setSelectedValues}
                data={management?.data?.data}
                isLoading={management?.isLoading}
                filterType="management"
                selectedValues={selectedValues}
              />
            )}
            {(context?.selectedGroup === "subscription" ||
              context?.selectedGroup === "resource_group") && (
              <Filter
                tittle={name}
                setSelectedTittle={setSelectedTittle}
                setSelectedValues={setSelectedValues}
                data={dropdown?.data?.data}
                isLoading={dropdown?.isLoading}
                filterType="account"
                selectedValues={selectedValues}
              />
            )}

            {context?.selectedGroup === "resource_group" && (
              <Filter
                tittle={"Resource Group"}
                setSelectedTittle={setSelectedTittle}
                setSelectedValues={setSelectedValues}
                data={azureFilterRg?.data?.data}
                isLoading={azureFilterRg?.isLoading}
                filterType="ResourceGroup"
                selectedValues={selectedValues}
              />
            )}
          </>
        )}
        {service === "gcp" && (
          <>
            <span className="filterScopeSelection">Scope</span>
            <span
              className="radioButtonContainer"
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: "16px",
              }}
            >
              <RadioButton
                name="scope"
                value="organization"
                title="Organization"
                contextKey="selectedGcpRadio"
              />
              <RadioButton
                name="scope"
                value="folder"
                title="Folder"
                contextKey="selectedGcpRadio"
              />
              <RadioButton
                name="scope"
                value="project"
                title="Project"
                contextKey="selectedGcpRadio"
              />
            </span>

            {context?.selectedGcpRadio === "project" && (
              <Filter
                tittle={"Project"}
                setSelectedTittle={setSelectedTittle}
                setSelectedValues={setSelectedValues}
                data={totaldata?.data}
                isLoading={gcpLoading}
                filterType="account"
                selectedValues={selectedValues}
              />
            )}
            {context?.selectedGcpRadio === "organization" && (
              <Filter
                tittle={"Organization"}
                setSelectedTittle={setSelectedTittle}
                setSelectedValues={setSelectedValues}
                data={totaldata?.data}
                isLoading={gcpLoading}
                filterType="account"
                selectedValues={selectedValues}
              />
            )}

            {context?.selectedGcpRadio === "folder" && (
              <Filter
                tittle={"Folder"}
                setSelectedTittle={setSelectedTittle}
                setSelectedValues={setSelectedValues}
                data={totaldata?.data}
                isLoading={gcpLoading}
                filterType="Folder"
                selectedValues={selectedValues}
              />
            )}
          </>
        )}

        <div className={styles.filterContainerBudgets}>
          <hr className="w-100 mb-0 mt-3px" />
          <div
            className={styles.filter_name_addsign}
            style={{ marginBottom: "-8px" }}
          >
            <div className={styles.filter_name}>Tag</div>
            <div>
              <Button
                variant="link"
                className="pt-0"
                // onClick={() => {
                //   const lastTag = selectedTags[selectedTags.length - 1];
                //   if (lastTag && lastTag.values.length > 0) {
                //     setCount((prev) => prev + 1);
                //     if (count < dimensionKeys?.data.length) {
                //       setSelectedTags((arr) => {
                //         const newArr = [...arr];
                //         newArr.push({
                //           filterOn: "",
                //           filterType: "include",
                //           values: [],
                //         });
                //         return newArr;
                //       });
                //     }
                //   }
                // }}
                 onClick={() => {
                    setSelectedTags((arr) => {
                      const newArr = [...arr];
                      newArr.push({
                        filterOn: "",
                        filterType: "include",
                        values: [],
                      });
                      return newArr;
                    });
                  }}
                style={{
                  opacity:
                    selectedTags.length === 0 ||
                    selectedTags[selectedTags.length - 1].values.length === 0
                      ? 0.5
                      : 1,
                  cursor:
                    selectedTags.length === 0 ||
                    selectedTags[selectedTags.length - 1].values.length === 0
                      ? "auto"
                      : "pointer",
                     
                }}
              >
                <img src={add} alt="" />
              </Button>
            </div>
          </div>
          {(selectedTags || []).map((tag, index) => (
            <TagItem
              service={service}
              tag={tag}
              index={index}
              setSelectedTags={setSelectedTags}
              selectedTags={selectedTags}
              tagItems={dimensionKeys?.data || []}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default BudgetFilterSection;

const Filter = ({
  tittle,
  data,
  isLoading,
  setSelectedValues,
  setSelectedTittle,
  filterType,
  selectedValues,
}) => {
  const [selectV, setSelectV] = useState({});
  const [tempSelectedValues, setTempSelectedValues] = useState([]);
  const [currentSelectedValues, setCurrentSelectedValues] = useState([]);
  const [applyTrue, setApplyTrue] = useState(false);
  const navigate = useNavigate();
  const handleTagSelection = () => {
    // Reset page to 1 when a filter is selected
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("page", "1");
    navigate(`?${searchParams.toString()}`);
  };

  const handleRemove = (selectedList) => {
    setSelectedValues((prevValues) => {
      return {
        ...prevValues,
        [filterType]: selectedList,
      };
    });
  };

  const handleTittle = (title) => {
    if (title === "Subscription") {
      title = "Account";
    }
    setSelectedTittle(title?.toLowerCase());
  };

  const handleApply = () => {
    setSelectedValues((prev) => ({
      ...prev,
      [filterType]: tempSelectedValues,
    }));
    setCurrentSelectedValues(tempSelectedValues);
  };

  const handleCancel = () => {
    setTempSelectedValues(currentSelectedValues);
  };

  useEffect(() => {
    setTempSelectedValues(selectedValues[filterType] || []);
    setCurrentSelectedValues(selectedValues[filterType] || []);
  }, [selectedValues[filterType]]);

  return (
    <div className={styles.filterContainerBudgets}>
      <div className={styles.dimension_div}>
        <div className={styles.dimension_name_css}>{tittle}</div>
        <div
          style={{ position: "relative", width: "100%" }}
          onClick={() => handleTittle(tittle)}
        >
          <FilterSearch
            multiselect={true}
            showApply
            applyTrue={applyTrue}
            setApplyTrue={setApplyTrue}
            loading={isLoading}
            options={(data || []).map((e) => {
              return {
                id: e?.id,
                name: e?.name,
              };
            })}
            // selectedValues={selectedValues[filterType] || []}
            // onSelect={(list) => {
            //   handleRemove(list);
            //   handleTagSelection();
            // }}
            // onRemove={(list) => {
            //   handleRemove(list);
            // }}
            selectedValues={tempSelectedValues}
            onSelect={(list) => {
              setTempSelectedValues(list);
              handleTagSelection();
            }}
            onRemove={(list) => setTempSelectedValues(list)}
            displayValue="name"
            placeholder={tittle}
            toggle={
              <>
                <FilterSearchToggle placeholder={tittle} />
              </>
            }
            onCancel={() => {
              handleCancel();
            }}
            onApply={() => {
              handleApply();
            }}
          />
        </div>
      </div>
    </div>
  );
};

// export const RadioButton = ({ name, title, value }) => {
//   const context = useContext(BudgetContext);
//   const handleChange = (e) => {
//     const newValue = e.target.value;
//     context?.setSelectedGroup(newValue);
//     context?.setSelectedGcpRadio(newValue);
//   };

//   return (
//     <div className="radioButtonSection">
//       <input
//         style={{ cursor: "pointer" }}
//         type="radio"
//         name={name}
//         id={value}
//         value={value}
//         checked={context?.selectedGroup === value}
//         onChange={handleChange}
//       />
//       <label htmlFor={value} style={{ cursor: "pointer" }}>
//         {title}
//       </label>
//     </div>
//   );
// };

export const RadioButton = ({ name, title, value, contextKey }) => {
  const context = useContext(BudgetContext);

  const handleChange = (e) => {
    const newValue = e.target.value;

    context?.setSelectedGroup(newValue);
    context?.setSelectedGcpRadio(newValue);
    if (newValue.toLowerCase() !== "resource_group") {
      context?.setIsRadioChanged(true);
    } else {
      context?.setIsRadioChanged(false);
    }
  };

  return (
    <div className="radioButtonSection">
      <input
        style={{ cursor: "pointer" }}
        type="radio"
        name={name}
        id={value}
        value={value}
        checked={context?.[contextKey] === value}
        onChange={handleChange}
      />
      <label htmlFor={value} style={{ cursor: "pointer" }}>
        {title}
      </label>
    </div>
  );
};
